/**
 * СК ФЕРМА (company id 21) — без UI оцифровки.
 * На остальных фермах оцифровка остаётся как есть.
 */
const COMPANIES_WITHOUT_DIGITIZATION_UI = new Set([21])

export const hideDigitizationUi = (companyId?: number | null): boolean =>
	companyId != null && COMPANIES_WITHOUT_DIGITIZATION_UI.has(companyId)

/** Виджеты главной, которые показывают блок «Оцифровано». */
export const DIGITIZATION_WIDGET_TYPES = new Set([
	'IDENTIFICATE',
	'IDENTIFICATE_WITH_NOTIF',
	'IDENTIFICATE_WITH_NOTIF_MEDIUM',
])

export const isDigitizationWidgetType = (type: string): boolean =>
	DIGITIZATION_WIDGET_TYPES.has(type)
